var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"asd20-thumbnail-avatar",class:_vm.classes},[_c('img',{attrs:{"src":_vm.thumbnail,"alt":_vm.label}})])
}
var staticRenderFns = []

export { render, staticRenderFns }